import React, { PropsWithChildren } from 'react';
import { NativeProps } from '@/src/components/interfaces';
import classNames from 'classnames';
import { CTextColor } from '@/src/components/c-text/CText';

export enum CListType {
  Order = 'ordered',
  Unordered = 'unordered',
}

export interface CListProps extends NativeProps {
  type?: CListType;
}

export function CList({
  type = CListType.Unordered,
  class: className,
  onClick,
  testSelector,
  id,
  children,
}: PropsWithChildren<CListProps>): React.JSX.Element {
  if (type === CListType.Unordered) {
    return (
      <ul id={id} onClick={onClick} data-test-selector={testSelector} className={classNames('c-list', className)}>
        {children}
      </ul>
    );
  }

  return (
    <ol id={id} onClick={onClick} data-test-selector={testSelector} className={classNames('c-list', className)}>
      {children}
    </ol>
  );
}